import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const getNodeSize = TiptapContentResolver.create((_, __, editor) => {
  const node = editor?.state?.selection?.node;
  if (node) {
    return node.attrs?.containerData?.width?.size;
  } else {
    return void 0;
  }
});
export {
  getNodeSize
};
//# sourceMappingURL=get-node-size.js.map
